import React from 'react'
import PropTypes from 'prop-types'

const CustomLayout = ({ children }) => {
  return <>{children}</>
}

export default CustomLayout

CustomLayout.propTypes = {
  props: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.oneOf([null]),
  ]).isRequired,
}
